export default __webpack_public_path__ + "static/media/upload-icon.a40a93dc.png";